import { useQueryClient } from "@tanstack/react-query"
import { type RealtimeMessage, TICKET_EVENT_NAMES } from "@zplanem/responses"
import { useCallback } from "react"
import { queryKeys } from "../../lib/query-keys"
import { ticketBoardCacheRoot } from "./ticket-api-paths"
import { ticketRealtimeInvalidationScope } from "./ticket-realtime-invalidation-model"
import { usePerUserChannelEvents } from "./use-per-user-channel-event"

export function useTicketRealtimeInvalidation(
	userId: string | undefined,
): void {
	const queryClient = useQueryClient()
	const handler = useCallback(
		(data: unknown) => {
			const scope = ticketRealtimeInvalidationScope(data as RealtimeMessage)
			if (!scope) return

			void queryClient.invalidateQueries({
				queryKey: queryKeys.myTicketsRoot(),
			})

			if (scope.kind === "access_lost") {
				void queryClient.invalidateQueries({
					predicate: (query) =>
						query.queryKey[0] === "properties" &&
						query.queryKey[2] === "tickets",
				})
				return
			}

			void queryClient.invalidateQueries({
				queryKey: ticketBoardCacheRoot(scope.propertyId),
			})
			void queryClient.invalidateQueries({
				queryKey: queryKeys.ticket(scope.propertyId, scope.ticketId),
			})
			void queryClient.invalidateQueries({
				queryKey: queryKeys.ticketComments(scope.propertyId, scope.ticketId),
			})
		},
		[queryClient],
	)

	usePerUserChannelEvents(userId, TICKET_EVENT_NAMES, handler)
}
